import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

class LineMap extends Component {

    constructor( props ){
        super( props );

        this.state = {
            isVisible: false
        };

        this.dpr = window.devicePixelRatio || 1;
        this.lineTimer = null;
        this.canvasEl = React.createRef();
        this.canvasCont = null;
    }

    componentDidMount() {
        // Set canvas height;
        this.canvasEl.current.width = window.innerWidth * this.dpr;
        this.canvasEl.current.height = window.innerHeight * this.dpr;

        this.canvasCont = this.canvasEl.current.getContext("2d");
        this.canvasCont.scale( this.dpr, this.dpr );
    }


    componentWillUnmount() {
        clearTimeout( this.lineTimer );
    }

    componentDidUpdate( prevProps ) {
        const { featureIndicatorReference, featureObjectPosition, featureTitle } = this.props;

        if( prevProps.featureTitle !== featureTitle || prevProps.featureObjectPosition === null && featureObjectPosition !== null ){
            this._clearCanvas();
            clearTimeout( this.lineTimer );

            if( featureIndicatorReference && featureObjectPosition ) {
                this.setState({
                    isVisible: false
                }, () => {
                    this._draw();
                });
            }
        }
    }

    _draw() {
        this.lineTimer = setTimeout(() => {
            this._drawLine();
            this._drawCircle();
            this.setState({
                isVisible: true
            });
        }, 1000);
    }

    _drawLine() {
        const { featureIndicatorReference, featureObjectPosition } = this.props;

        // Double check this is set in case it's changed before line is drawn.
        if( featureObjectPosition === null ) {
            return false;
        }

        const box = featureIndicatorReference.getBoundingClientRect();

        // Middle of indicator.
        let boxCentreX = box.x + box.width/2;
        let boxCentreY=  box.y + box.height/2;

        // Draw line between object and indicator.
        this.canvasCont.lineWidth = 4;
        this.canvasCont.strokeStyle = '#F3E500';
        this.canvasCont.beginPath();
        this.canvasCont.moveTo(boxCentreX,boxCentreY);
        this.canvasCont.lineTo(featureObjectPosition.x+30,featureObjectPosition.y);
        this.canvasCont.stroke();
    }

    _drawCircle() {
        const { featureObjectPosition } = this.props;

        // Double check this is set in case it's changed before line is drawn.
        if( featureObjectPosition === null ) {
            return false;
        }

        // Draw circle around feature.
        this.canvasCont.lineWidth = 4;
        this.canvasCont.strokeStyle = '#F3E500';
        this.canvasCont.beginPath();
        this.canvasCont.arc(featureObjectPosition.x,featureObjectPosition.y, 30, 0, 2*Math.PI);
        this.canvasCont.stroke();
    }

    _clearCanvas() {
        const { isVisible } = this.state;
        this.canvasCont.clearRect(0,0,this.canvasEl.current.width, this.canvasEl.current.height);
        clearTimeout( this.lineTimer );
    }

    render() {
        const { isVisible } = this.state;
        const classes = classnames(
            "line-map",
            { "hidden" : !isVisible }
        );

        return(
            <canvas className={ classes } ref={ this.canvasEl } />
        );
    }

}

const mapStateToProps = ( state ) => {
    return {
        featureIndicatorReference: state.featureMap.featureIndicator,
        featureTitle: state.featureMap.featureTitle,
        featureObjectPosition: state.featureMap.objectIndicatorPos
    }
};

export default connect(mapStateToProps)(LineMap);



// WEBPACK FOOTER //
// ./src/components/line-map.js